export const selectCountry = ({ commit }, payload) => {
    commit('setSelectedCountry', payload);
};

export const setCountryPackages = ({ commit }, payload) => {
    commit('setCountryPackages', payload);
};

export const setPlanDevices = ({ commit }, payload) => {
    commit('setPlanDevices', payload);
};

export const setStartDate = ({ commit }, payload) => {
    commit('setStartDate', payload);
    commit('toggleReturnDate');
};

export const setEndDate = ({ commit }, payload) => {
    commit('setEndDate', payload);
    commit('toggleReturnDate');
};

export const setNumberOfDays = ({ commit }, payload) => {
    commit('setNumberOfDays', payload);
    commit('toggleReturnDate');
};

export const setPlanType = ({ commit }, payload) => {
    commit('setPlanType', payload);
};

export const setSelectedDevice = ({ commit }, payload) => {
    commit('setSelectedDevice', payload);
};

export const setNumberOfDevices = ({ commit }, payload) => {
    commit('setNumberOfDevices', payload);
};

export const selectPlan = ({ commit }, payload) => {
    commit('setSelectedPlan', payload);
};

export const setShipmentType = ({ commit }, payload) => {
    commit('setShipmentType', payload);
};

export const setDeliveryForm = ({ commit }, payload) => {
    commit('setDeliveryForm', payload);
};

export const setPickupLocation = ({ commit }, payload) => {
    commit('setPickupLocation', payload);
};

export const setPickupDate = ({ commit }, payload) => {
    commit('setPickupDate', payload);
};

export const setDeliveryType = ({ commit }, payload) => {
    commit('setDeliveryType', payload);
};

export const clearShipmentPickupType = ({ commit }) => {
    commit('setPickupLocation', {});
    commit('setPickupDate', null);
};

export const clearShipmentDeliveryType = ({ commit }) => {
    commit('setDeliveryType', {});
    commit('setDeliveryForm', {});
};

export const setCoupon = ({ commit }, payload) => {
    commit('setCoupon', payload);
};

export const setGiftCard = ({ commit }, payload) => {
    commit('setGiftCard', payload);
};

export const setInsuranceStatus = ({ commit }, payload) => {
    commit('setInsuranceStatus', payload);
};

export const setReturnDate = ({ commit }, payload) => {
    commit('setReturnDate', payload);
};

export const setOrderData = ({ commit, getters }, payload) => {
    commit('setOrderData', payload);
};

export const clearOrderData = ({ commit, getters }, payload) => {
    commit('clearOrderData', payload);
};

export const setActiveOrderDataIndex = ({commit, getters}, payload) => {
    commit('setActiveOrderDataIndex', payload);
};

export const removeOrderDataByIndex = ({state, commit}, payload) => {
    let orderData = _.cloneDeep(state.orderData);
    orderData.splice(payload, 1);
    commit('setOrderData', orderData);
    commit('setActiveOrderDataIndex', state.activeOrderDataIndex - 1);
};

export const addAnotherOrderData = ({ commit, state }) => {
    let newOrderData = _.cloneDeep(state.orderDataTemplate);
    let orderData = _.cloneDeep(state.orderData);

    orderData.push(newOrderData);

    commit('setCountryPackages', []);
    commit('setOrderData', orderData);
    commit('setActiveOrderDataIndex', state.activeOrderDataIndex + 1);
};

export const setPickupLocations = ({ commit }, payload) => {
    commit('setPickupLocations', payload);
};

export const fetchDestinations = async ({ commit }, payload) => {
    try {
        const res = await axios.get(`/countries/search`, {
            params: {
                query: payload.query,
                limit: payload.limit,
            }
        });

        const destinations = await res.data;
        commit('setDestinations', destinations);
        return destinations;
    } catch (error) {
        console.error("Error while fetching search results:", error);
    }
}
